import { Disclosure } from "@headlessui/react";
import { FAQSectionTitle } from "./components/faq-section-title";
import { FAQButton } from "./components/faq-button";
import { FAQItem } from "./components/faq-item";
import { FAQItemList } from "./components/faq-item-list";
import { Text } from "../../components/text";

export const FAQRegistrationAndLogin = () => {
  return (
    <>
      <FAQSectionTitle>
        Registrasi dan Masuk
      </FAQSectionTitle>

      <Disclosure>
        <FAQButton>
          Bagaimana cara membuat akun di Jooalan?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Install aplikasi Jooalan',
              'Buka aplikasi Jooalan',
              'Klik menu akun',
              'Pilih masuk dengan Nomor telepon atau email',
              'Isikan nama lengkap, nama toko, jenis usaha, alamat, dan kode spesial/ referral (jika ada)',
              'Masukkan kata sandi hanya untuk yang masuk dengan nomor telepon',
              'Klik lanjutkan dan akun terbuat',
            ]}
          />
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana cara masuk di Jooalan?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik menu akun',
              'Pilih masuk dengan nomor telepon atau masuk dengan email',
              'Jika pilih nomor telepon, masukkan nomor telepon dan kata sandi',
              'Jika pilih email, pilih gmail',
            ]}
          />
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Saya lupa kata sandi, bagaimana cara membuat kata sandi baru?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik menu akun',
              'Pilih Masuk dengan nomor telepon',
              'Masukkan nomor telepon',
              'Klik lupa kata sandi',
              'Pilih metode verifikasi OTP',
              'Masukkan kata sandi baru',
              'Klik lanjutkan',
            ]}
          />
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana cara mengubah kata sandi saya?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik menu akun',
              'Klik pengaturan akun',
              'Klik Ubah kata sandi',
              'Masukkan kata sandi lama',
              'Masukkan kata sandi baru',
              'Klik simpan',
            ]}
          />
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana cara menambahkan nomor HP akun?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik menu akun',
              'Klik lengkapi di bagian atas menu akun atau klik pengaturan akun',
              'Klik nomor telepon',
              'Isikan nomor telepon',
              'Isikan OTP ',
              'Masukkan kata sandi',
              'Klik lanjutkan',
            ]}
          />
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana cara menambahkan email akun?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik menu akun',
              'Klik lengkapi di bagian atas menu akun atau klik pengaturan akun',
              'Klik email',
              'Pilih gmail yang ingin ditambahkan',
            ]}
          />
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana cara masuk ke akun Jooalan?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik menu akun',
              'Pilih untuk masuk dengan nomor telepon atau email',
              'Jika pilih email, silahkan pilih gmail yang sudah pernah didaftarkan',
              'Jika pilih nomor telepon, silahkan masukkan nomor telepon yang sudah pernah didaftarkan dan masukkan kata sandinya',
            ]}
          />
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Apakah saya dapat mendaftarkan nomor telepon rumah saya untuk
          verifikasi nomor handphone?
        </FAQButton>
        <FAQItem>
          <Text>
            Tidak bisa. Saat ini nomor yang bisa didaftarkan dan diverifikasi
            hanya nomor handphone karena kode verifikasi akan dikirimkan melalui
            SMS atau WhatsApp
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Apakah saya dapat melakukan verifikasi nomor handphone untuk dua akun?
        </FAQButton>
        <FAQItem>
          <Text>
            Tidak, satu nomor handphone hanya bisa didaftarkan dan diverifikasi
            untuk satu akun.
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Apakah saya dapat melakukan verifikasi email untuk dua akun?
        </FAQButton>
        <FAQItem>
          <Text>
            Tidak, satu email hanya bisa didaftarkan dan diverifikasi untuk satu
            akun
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana cara mengubah data akun saya?
        </FAQButton>
        <FAQItem>
          <FAQItemList
            numbered
            data={[
              'Klik menu akun',
              'Klik pengaturan akun',
              'Klik data yang ingin diubah dari akun',
              'Klik SIMPAN untuk menyimpan perubahan',
            ]}
          />
        </FAQItem>
      </Disclosure>
    </>
  )
}